import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shortCurrency'
})
export class ShortCurrencyPipe implements PipeTransform {

  transform(value: number, ...args: unknown[]): unknown {

    if (value === null || value === undefined) return '';

    let formattedValue = '';

    if (value >= 1e9) {
      formattedValue = (value / 1e9).toFixed(1) + 'B';
    } else if (value >= 1e6) {
      formattedValue = (value / 1e6).toFixed(1) + 'M';
    } else if (value >= 1e3) {
      formattedValue = (value / 1e3).toFixed(1) + 'k';
    } else {
      formattedValue = value.toFixed(2);
    }
    return formattedValue;
  }

}
